var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "#8A8A8A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 18L26.4528 12.2138C27.1824 11.4843 27.1824 10.2767 26.4528 9.54717C25.7233 8.81761 24.5157 8.81761 23.7862 9.54717L18 15.3333L12.2138 9.54717C11.4843 8.81761 10.2767 8.81761 9.54717 9.54717C8.81761 10.2767 8.81761 11.4843 9.54717 12.2138L15.3333 18L9.54717 23.7862C8.81761 24.5157 8.81761 25.7233 9.54717 26.4528C9.92453 26.8302 10.4025 27.0063 10.8805 27.0063C11.3585 27.0063 11.8365 26.8302 12.2138 26.4528L18 20.6667L23.7862 26.4528C24.1635 26.8302 24.6415 27.0063 25.1195 27.0063C25.5975 27.0063 26.0755 26.8302 26.4528 26.4528C27.1824 25.7233 27.1824 24.5157 26.4528 23.7862L20.6667 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX5);
export default __webpack_public_path__ + "static/media/x5.ecd2b051ad5c3bc337eca6435883f4e4.svg";
export { ForwardRef as ReactComponent };